import React from "react";
import { FormInput } from "@/shared/Components";
import type { InputProps } from "antd/lib";

export const FormFields: React.FC<InputProps> = ({ ...props }) => {
  return <FormInput placeholder="Tag name" name="tag" {...props} maxLength={30} />;
};
